<template>
  <div class="research-page">
    <!-- ===== 01 顶部定位区 Hero ===== -->
    <section class="gradient-blue text-white relative">
        <div class="max-w-6xl mx-autopx-4 sm:px-8">
            <div class="max-w-5xl">
                <h1>
                    <span class="text-white/90">
                        古杉研究中心 · 数据治理知识库<br>
                    </span>
                    <span class="text-white/90">数字化研究 · 政策解读 · 白皮书</span>
                </h1>
                <p class="mt-6 text-xl text-white/80 max-w-2xl">
                    专注央企国企数字化转型、数据治理、审计风控领域的前沿研究与最佳实践，为决策者提供权威参考。
                </p>

                <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-12">
                    <div class="flex flex-wrap gap-4">
                        <h2 class="tag">审计数字化能力模型</h2>
                        <h2 class="tag">审计成熟度评估</h2>
                        <h2 class="tag">穿透式风险管理</h2>
                        <h2 class="tag">数据治理能力成熟度</h2>
                        <h2 class="tag">数据合规治理体系</h2>
                        <h2 class="tag">数据资产运营体系</h2>
                        <h2 class="tag">数字化工程师能力模型</h2>
                        <h2 class="tag">复合型数字人才</h2>
                        <h2 class="tag">数字化赋能体系</h2>
                        <h2 class="tag">数字化人才培养</h2>
                        <h2 class="tag">数据分析能力</h2>
                        <h2 class="tag">AI能力建设</h2>
                        <h2 class="tag">数字化能力建设方案</h2>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- ===== 02 研究领域 ===== -->
    <section class="py-12 bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="mb-6">
                <h2 class="text-3xl md:text-4xl font-bold text-[#0E1F52]">央企数字化-数据治理研究-审计风控-政策解读</h2>
                <p class="mt-4 text-lg text-[#5A5E66]">追踪央企国企数字化转型最新趋势，解读行业标杆案例</p>
            </div>
            <div class="mt-8 grid md:grid-cols-5 gap-6">
                <div class="text-center p-4 bg-[#F6F8FC] rounded-xl border border-divider card-hover">
                    <span class="text-3xl block mb-2">🚀</span>
                    <h3 class="text-lg font-bold text-[#0E1F52]">数字化研究</h3>
                    <p class="text-sm text-[#5A5E66] mt-2">转型趋势与路径</p>
                </div>
                <div class="text-center p-4 bg-[#F6F8FC] rounded-xl border border-divider card-hover">
                    <span class="text-3xl block mb-2">📚</span>
                    <h3 class="text-lg font-bold text-[#0E1F52]">数据治理知识库</h3>
                    <p class="text-sm text-[#5A5E66] mt-2">方法论与实践</p>
                </div>
                <div class="text-center p-4 bg-[#F6F8FC] rounded-xl border border-divider card-hover">
                    <span class="text-3xl block mb-2">📈</span>
                    <h3 class="text-lg font-bold text-[#0E1F52]">审计风控趋势</h3>
                    <p class="text-sm text-[#5A5E66] mt-2">技术与应用</p>
                </div>
                <div class="text-center p-4 bg-[#F6F8FC] rounded-xl border border-divider card-hover">
                    <span class="text-3xl block mb-2">⚖️</span>
                    <h3 class="text-lg font-bold text-[#0E1F52]">政策解读</h3>
                    <p class="text-sm text-[#5A5E66] mt-2">监管与合规</p>
                </div>
                <div class="text-center p-4 bg-[#F6F8FC] rounded-xl border border-divider card-hover">
                    <span class="text-3xl block mb-2">📄</span>
                    <h3 class="text-lg font-bold text-[#0E1F52]">白皮书下载</h3>
                    <p class="text-sm text-[#5A5E66] mt-2">深度报告</p>
                </div>
            </div>
        </div>
    </section>

    <!-- ===== 03 数字化研究 ===== -->
    <section id="digital" class="py-20 bg-[#F6F8FC]">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="mb-12">
                <h2 class="text-3xl md:text-4xl font-bold text-[#0E1F52]">数字化研究</h2>
                <p class="mt-4 text-lg text-[#5A5E66]">追踪央企国企数字化转型最新趋势，解读行业标杆案例</p>
            </div>
            <div class="grid md:grid-cols-4 gap-8">
                <div class="bg-white p-6 rounded-xl border border-divider card-hover">
                    <div class="flex items-start gap-3 mb-3">
                        <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">2026-03</span>
                        <span class="text-xs text-[#5A5E66] bg-porcelain px-3 py-1 rounded-full">实战指南</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">企业如何做数字化转型：从战略规划到落地实施全指南</h3>
                    <p class="text-[#5A5E66] text-sm leading-relaxed mb-4">系统化方法论、五阶段实施路径、三大行业标杆案例，助力企业构建数字化核心竞争力。</p>
                    <router-link to="/blog/article/digital-transformation-guide" class="text-brand text-sm font-medium hover:underline">阅读全文 →</router-link>
                </div>
                <div class="bg-white p-6 rounded-xl border border-divider card-hover">
                    <div class="flex items-start gap-3 mb-3">
                        <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">2026-02</span>
                        <span class="text-xs text-[#5A5E66] bg-porcelain px-3 py-1 rounded-full">趋势报告</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">2026年央企数字化转型趋势报告</h3>
                    <p class="text-[#5A5E66] text-sm leading-relaxed mb-4">基于100+央企调研，深度解析数字化转型的关键成功要素、典型场景和未来方向。涵盖数据治理、智能审计、AI应用等核心领域。</p>
                    <router-link to="/blog/article/soe-digital-trend-2026" class="text-brand text-sm font-medium hover:underline">阅读全文 →</router-link>
                </div>
                <div class="bg-white p-6 rounded-xl border border-divider card-hover">
                    <div class="flex items-start gap-3 mb-3">
                        <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">2026-01</span>
                        <span class="text-xs text-[#5A5E66] bg-porcelain px-3 py-1 rounded-full">案例研究</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">能源行业数字化转型标杆案例集</h3>
                    <p class="text-[#5A5E66] text-sm leading-relaxed mb-4">国家能源集团、中石油、国家电网等领军企业的数字化转型实践，从战略规划到落地实施的全流程复盘。</p>
                    <router-link to="/blog/article/energy-case-studies" class="text-brand text-sm font-medium hover:underline">阅读全文 →</router-link>
                </div>
                <div class="bg-white p-6 rounded-xl border border-divider card-hover">
                    <div class="flex items-start gap-3 mb-3">
                        <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">2025-12</span>
                        <span class="text-xs text-[#5A5E66] bg-porcelain px-3 py-1 rounded-full">行业观察</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">制造业数字化转型的五大挑战与破局之道</h3>
                    <p class="text-[#5A5E66] text-sm leading-relaxed mb-4">从一汽集团、中船重工等制造业龙头企业的实践中，总结数字化转型的关键难点及解决方案。</p>
                    <router-link to="/blog/article/manufacturing-challenges" class="text-brand text-sm font-medium hover:underline">阅读全文 →</router-link>
                </div>
            </div>
        </div>
    </section>

    <!-- ===== 04 数据治理知识库 ===== -->
    <section id="governance" class="py-20 bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="mb-12">
                <h2 class="text-3xl md:text-4xl font-bold text-[#0E1F52]">数据治理知识库</h2>
                <p class="mt-4 text-lg text-[#5A5E66]">系统化数据治理方法论、工具模板、最佳实践</p>
            </div>
            <div class="grid md:grid-cols-2 gap-8">
                <div class="bg-porcelain p-8 rounded-xl border border-divider">
                    <span class="text-4xl block mb-4">📖</span>
                    <h3 class="text-2xl font-bold text-[#0E1F52] mb-3">DCMM认证指南</h3>
                    <p class="text-[#5A5E66] mb-4">数据管理能力成熟度模型（DCMM）国家标准解读、认证流程、评估工具、案例分享。</p>
                    <ul class="space-y-2 text-sm text-[#5A5E66] mb-4">
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span>DCMM五级成熟度模型详解</li>
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span>八大能力域评估工具包</li>
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span>认证申报流程与材料清单</li>
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span>典型企业认证案例（已过四级）</li>
                    </ul>
                    <router-link to="/blog/article/dcmm-guide" class="text-brand font-medium hover:underline">查看知识库 →</router-link>
                </div>
                <div class="bg-porcelain p-8 rounded-xl border border-divider">
                    <span class="text-4xl block mb-4">🗂️</span>
                    <h3 class="text-2xl font-bold text-[#0E1F52] mb-3">主数据管理实践</h3>
                    <p class="text-[#5A5E66] mb-4">主数据定义、标准制定、系统建设、运营体系，从0到1建立企业级主数据管理体系。</p>
                    <ul class="space-y-2 text-sm text-[#5A5E66] mb-4">
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span><router-link :to="{ path: '/blog/article/master-data-management', hash: '#section3' }" class="hover:text-brand hover:underline">客户主数据标准模板</router-link></li>
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span><router-link :to="{ path: '/blog/article/master-data-management', hash: '#section4' }" class="hover:text-brand hover:underline">产品主数据治理流程</router-link></li>
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span><router-link :to="{ path: '/blog/article/master-data-management', hash: '#section5' }" class="hover:text-brand hover:underline">组织架构主数据设计</router-link></li>
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span><router-link :to="{ path: '/blog/article/master-data-management', hash: '#section6' }" class="hover:text-brand hover:underline">主数据质量监控方案</router-link></li>
                    </ul>
                    <router-link :to="{ path: '/blog/article/master-data-management', hash: '#section1' }" class="text-brand font-medium hover:underline">查看知识库 →</router-link>
                </div>
                <div class="bg-porcelain p-8 rounded-xl border border-divider">
                    <span class="text-4xl block mb-4">📊</span>
                    <h3 class="text-2xl font-bold text-[#0E1F52] mb-3">指标体系建设</h3>
                    <p class="text-[#5A5E66] mb-4">企业级指标体系规划、指标定义标准、口径统一方法、指标字典模板。</p>
                    <ul class="space-y-2 text-sm text-[#5A5E66] mb-4">
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span><router-link :to="{ path: '/blog/article/metrics-system', hash: '#section2' }" class="hover:text-brand hover:underline">指标分层模型（战略-战术-运营）</router-link></li>
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span><router-link :to="{ path: '/blog/article/metrics-system', hash: '#section5' }" class="hover:text-brand hover:underline">指标字典Excel模板</router-link></li>
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span><router-link :to="{ path: '/blog/article/metrics-system', hash: '#section4' }" class="hover:text-brand hover:underline">指标口径统一方法论</router-link></li>
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span><router-link :to="{ path: '/blog/article/metrics-system', hash: '#section6' }" class="hover:text-brand hover:underline">指标血缘管理实践</router-link></li>
                    </ul>
                    <router-link :to="{ path: '/blog/article/metrics-system', hash: '#section1' }" class="text-brand font-medium hover:underline">查看知识库 →</router-link>
                </div>
                <div class="bg-porcelain p-8 rounded-xl border border-divider">
                    <span class="text-4xl block mb-4">✅</span>
                    <h3 class="text-2xl font-bold text-[#0E1F52] mb-3">数据质量管理</h3>
                    <p class="text-[#5A5E66] mb-4">数据质量评估框架、质量规则库、问题根因分析、整改闭环管理。</p>
                    <ul class="space-y-2 text-sm text-[#5A5E66] mb-4">
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span><router-link :to="{ path: '/blog/article/data-quality-management', hash: '#section2' }" class="hover:text-brand hover:underline">六维质量评估模型（准确性/完整性等）</router-link></li>
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span><router-link :to="{ path: '/blog/article/data-quality-management', hash: '#section3' }" class="hover:text-brand hover:underline">300+质量规则库</router-link></li>
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span><router-link :to="{ path: '/blog/article/data-quality-management', hash: '#section4' }" class="hover:text-brand hover:underline">质量问题根因分析方法</router-link></li>
                        <li class="flex items-start"><span class="w-1.5 h-1.5 bg-brand rounded-full mt-1.5 mr-2"></span><router-link :to="{ path: '/blog/article/data-quality-management', hash: '#section5' }" class="hover:text-brand hover:underline">质量改进PDCA闭环</router-link></li>
                    </ul>
                    <router-link :to="{ path: '/blog/article/data-quality-management', hash: '#section1' }" class="text-brand font-medium hover:underline">查看知识库 →</router-link>
                </div>
            </div>
        </div>
    </section>

    <!-- ===== 05 审计风控趋势 ===== -->
    <section id="trends" class="py-20 bg-[#F6F8FC]">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="mb-12">
                <h2 class="text-3xl md:text-4xl font-bold text-[#0E1F52]">审计风控趋势</h2>
                <p class="mt-4 text-lg text-[#5A5E66]">智能审计、实时风控、AI应用的最新技术与案例</p>
            </div>
            <div class="space-y-6">
                <div class="bg-white p-8 rounded-xl border border-divider flex items-start gap-6">
                    <span class="text-5xl flex-shrink-0">🔍</span>
                    <div class="flex-grow">
                        <div class="flex items-center gap-3 mb-2">
                            <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">2026-02-10</span>
                            <span class="text-xs text-[#5A5E66] bg-porcelain px-3 py-1 rounded-full">技术趋势</span>
                        </div>
                        <h3 class="text-2xl font-bold text-[#0E1F52] mb-2">AI大模型在审计领域的应用前景</h3>
                        <p class="text-[#5A5E66] leading-relaxed">深度解析GPT、LLaMA等大模型如何赋能审计工作：智能审计报告生成、疑点解释、风险预测等场景。分享国内外5家领先企业的落地实践与ROI分析。</p>
                        <router-link to="/blog/article/ai-audit-trend" class="mt-3 inline-block text-brand font-medium hover:underline">阅读全文 →</router-link>
                    </div>
                </div>
                <div class="bg-white p-8 rounded-xl border border-divider flex items-start gap-6">
                    <span class="text-5xl flex-shrink-0">⚡</span>
                    <div class="flex-grow">
                        <div class="flex items-center gap-3 mb-2">
                            <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">2026-01-28</span>
                            <span class="text-xs text-[#5A5E66] bg-porcelain px-3 py-1 rounded-full">案例研究</span>
                        </div>
                        <h3 class="text-2xl font-bold text-[#0E1F52] mb-2">持续审计：从理论到实践的全景图</h3>
                        <p class="text-[#5A5E66] leading-relaxed">系统讲解持续审计的技术架构、实施路径、组织体系。通过某国有大行、某能源集团的真实案例，展示如何从传统审计向持续审计转型，实现审计覆盖率从15%到85%的飞跃。</p>
                        <router-link to="/blog/article/continuous-audit" class="mt-3 inline-block text-brand font-medium hover:underline">阅读全文 →</router-link>
                    </div>
                </div>
                <div class="bg-white p-8 rounded-xl border border-divider flex items-start gap-6">
                    <span class="text-5xl flex-shrink-0">🛡️</span>
                    <div class="flex-grow">
                        <div class="flex items-center gap-3 mb-2">
                            <span class="text-xs text-brand bg-porcelain px-3 py-1 rounded-full">2026-01-15</span>
                            <span class="text-xs text-[#5A5E66] bg-porcelain px-3 py-1 rounded-full">技术白皮书</span>
                        </div>
                        <h3 class="text-2xl font-bold text-[#0E1F52] mb-2">基于图计算的反洗钱与反欺诈技术</h3>
                        <p class="text-[#5A5E66] leading-relaxed">详细阐述图数据库、图计算引擎在金融反洗钱、保险反欺诈场景的应用。包含算法原理、技术选型、性能优化、部署架构。某股份制银行反洗钱系统落地案例深度解析。</p>
                        <router-link to="/blog/article/graph-computing-aml" class="mt-3 inline-block text-brand font-medium hover:underline">阅读全文 →</router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- ===== 06 政策解读 ===== -->
    <section id="policy" class="py-20 bg-white">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="mb-12">
                <h2 class="text-3xl md:text-4xl font-bold text-[#0E1F52]">政策解读</h2>
                <p class="mt-4 text-lg text-[#5A5E66]">权威解读国家政策、监管要求、行业标准</p>
            </div>
            <div class="grid md:grid-cols-2 gap-8">
                <div class="bg-porcelain p-8 rounded-xl border border-divider">
                    <div class="flex items-center gap-3 mb-3">
                        <span class="text-xs text-brand bg-white px-3 py-1 rounded-full">2026-01</span>
                        <span class="text-xs text-[#0E1F52] bg-white px-3 py-1 rounded-full">国家政策</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">《数据要素×行动计划》深度解读</h3>
                    <p class="text-[#5A5E66] leading-relaxed">国家发改委发布的数据要素行动计划对企业数字化转型的重大影响，如何把握数据要素化机遇，建立数据资产管理体系。</p>
                    <a href="#" class="mt-3 inline-block text-brand font-medium hover:underline">阅读全文 →</a>
                </div>
                <div class="bg-porcelain p-8 rounded-xl border border-divider">
                    <div class="flex items-center gap-3 mb-3">
                        <span class="text-xs text-brand bg-white px-3 py-1 rounded-full">2025-12</span>
                        <span class="text-xs text-[#0E1F52] bg-white px-3 py-1 rounded-full">金融监管</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">银保监会数据治理新规解读（2025版）</h3>
                    <p class="text-[#5A5E66] leading-relaxed">银保监会最新数据治理监管要求解读，对比旧版本的变化，银行保险机构如何应对新要求，落地实施路线图。</p>
                    <a href="#" class="mt-3 inline-block text-brand font-medium hover:underline">阅读全文 →</a>
                </div>
                <div class="bg-porcelain p-8 rounded-xl border border-divider">
                    <div class="flex items-center gap-3 mb-3">
                        <span class="text-xs text-brand bg-white px-3 py-1 rounded-full">2025-11</span>
                        <span class="text-xs text-[#0E1F52] bg-white px-3 py-1 rounded-full">行业标准</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">DCMM 3.0标准变化与应对策略</h3>
                    <p class="text-[#5A5E66] leading-relaxed">数据管理能力成熟度模型（DCMM）3.0版本的核心变化，新增能力项解读，企业如何从2.0平滑过渡到3.0。</p>
                    <a href="#" class="mt-3 inline-block text-brand font-medium hover:underline">阅读全文 →</a>
                </div>
                <div class="bg-porcelain p-8 rounded-xl border border-divider">
                    <div class="flex items-center gap-3 mb-3">
                        <span class="text-xs text-brand bg-white px-3 py-1 rounded-full">2025-10</span>
                        <span class="text-xs text-[#0E1F52] bg-white px-3 py-1 rounded-full">国企改革</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">国企数字化转型指导意见解读</h3>
                    <p class="text-[#5A5E66] leading-relaxed">国资委发布的央企国企数字化转型指导意见，对审计、风控、数据治理的具体要求，实施时间表和考核指标。</p>
                    <a href="#" class="mt-3 inline-block text-brand font-medium hover:underline">阅读全文 →</a>
                </div>
            </div>
        </div>
    </section>

    <!-- ===== 07 白皮书下载 ===== -->
    <section id="whitepaper" class="py-20 bg-[#F6F8FC]">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="mb-12 text-center">
                <h2 class="text-3xl md:text-4xl font-bold text-[#0E1F52]">白皮书下载</h2>
                <p class="mt-4 text-lg text-[#5A5E66]">深度研究报告，免费下载</p>
            </div>
            <div class="grid md:grid-cols-3 gap-8">
                <div class="bg-white p-8 rounded-xl border border-divider text-center card-hover">
                    <div class="w-20 h-24 mx-auto mb-4 bg-brand/10 rounded flex items-center justify-center">
                        <span class="text-4xl">📘</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">《2026央企数字化转型白皮书》</h3>
                    <p class="text-[#5A5E66] text-sm mb-4">120页深度报告，52MB PDF</p>
                    <button class="px-6 py-2 bg-brand text-white rounded-lg hover:bg-[#0E1F52] transition">立即下载</button>
                </div>
                <div class="bg-white p-8 rounded-xl border border-divider text-center card-hover">
                    <div class="w-20 h-24 mx-auto mb-4 bg-brand/10 rounded flex items-center justify-center">
                        <span class="text-4xl">📕</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">《银行业数据治理实施指南》</h3>
                    <p class="text-[#5A5E66] text-sm mb-4">80页实战指南，38MB PDF</p>
                    <button class="px-6 py-2 bg-brand text-white rounded-lg hover:bg-[#0E1F52] transition">立即下载</button>
                </div>
                <div class="bg-white p-8 rounded-xl border border-divider text-center card-hover">
                    <div class="w-20 h-24 mx-auto mb-4 bg-brand/10 rounded flex items-center justify-center">
                        <span class="text-4xl">📗</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">《智能审计技术白皮书》</h3>
                    <p class="text-[#5A5E66] text-sm mb-4">95页技术手册，45MB PDF</p>
                    <button class="px-6 py-2 bg-brand text-white rounded-lg hover:bg-[#0E1F52] transition">立即下载</button>
                </div>
                <div class="bg-white p-8 rounded-xl border border-divider text-center card-hover">
                    <div class="w-20 h-24 mx-auto mb-4 bg-brand/10 rounded flex items-center justify-center">
                        <span class="text-4xl">📙</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">《实时风控系统建设方案》</h3>
                    <p class="text-[#5A5E66] text-sm mb-4">70页架构设计，32MB PDF</p>
                    <button class="px-6 py-2 bg-brand text-white rounded-lg hover:bg-[#0E1F52] transition">立即下载</button>
                </div>
                <div class="bg-white p-8 rounded-xl border border-divider text-center card-hover">
                    <div class="w-20 h-24 mx-auto mb-4 bg-brand/10 rounded flex items-center justify-center">
                        <span class="text-4xl">📔</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">《指标体系建设最佳实践》</h3>
                    <p class="text-[#5A5E66] text-sm mb-4">60页实践案例，28MB PDF</p>
                    <button class="px-6 py-2 bg-brand text-white rounded-lg hover:bg-[#0E1F52] transition">立即下载</button>
                </div>
                <div class="bg-white p-8 rounded-xl border border-divider text-center card-hover">
                    <div class="w-20 h-24 mx-auto mb-4 bg-brand/10 rounded flex items-center justify-center">
                        <span class="text-4xl">📓</span>
                    </div>
                    <h3 class="text-xl font-bold text-[#0E1F52] mb-2">《AI大模型审计应用手册》</h3>
                    <p class="text-[#5A5E66] text-sm mb-4">55页应用指南，25MB PDF</p>
                    <button class="px-6 py-2 bg-brand text-white rounded-lg hover:bg-[#0E1F52] transition">立即下载</button>
                </div>
            </div>
        </div>
    </section>

    <!-- ===== 08 订阅研究 ===== -->
    <section id="subscribe" class="py-20 bg-white">
        <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 class="text-3xl md:text-4xl font-bold text-[#0E1F52]">订阅古杉研究</h2>
            <p class="mt-4 text-lg text-[#5A5E66]">每月接收最新研究报告、白皮书、政策解读</p>
            <div class="mt-10 flex justify-center gap-4">
                <input type="email" placeholder="请输入您的邮箱" class="px-6 py-3 w-80 border border-divider rounded-lg focus:border-brand focus:outline-none">
                <button class="px-8 py-3 bg-brand text-white rounded-lg hover:bg-[#0E1F52] transition">订阅</button>
            </div>
            <p class="mt-4 text-sm text-[#5A5E66]">已有8000+订阅者，我们尊重您的隐私</p>
        </div>
    </section>
  </div>
</template>

<script>
export default {
    name: 'Research'
}
</script>

<style scoped>
.research-page {
  background-color: var(--white);
}


.gradient-blue {
    background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
    width: 100%;
    padding: 60px 5%; /* 或者使用 px，如 padding: 60px 24px; */
}

h1 {
  font-size: 2.5rem;
  line-height: 1.2;
  font-weight: 700;
}

@media (min-width: 768px) {
  h1 {
    font-size: 3rem;
  }
}

.card-hover {
  transition: all 0.3s ease;
}

.card-hover:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(31, 63, 143, 0.15);
}


/* 标签组 */
.tag-list {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin: 24px 0 28px;
}
.tag {
    background: #ffffff;
    color: black;
    padding: 14px 28px;
    border-radius: 40px;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid rgba(26,115,232,0.15);
    /* margin-bottom: 10px;   */
    max-width: 0;
    max-width:fit-content;
}



</style>
